import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>This tool is designed to focus your thoughts on what you really
                                                value and how this affects your approach to your work and what
                                                you want out of life. Consider the following suggestions for
                                                practical next steps:</p>
                                            <div className="border_subtitle">Discuss your values and
                                                preferences
                                            </div>
                                            <p>Consider discussing these findings with someone you trust, such
                                                as a line manager, coach, mentor, colleague or even friends and
                                                family to gain different perspectives and to consider your way
                                                forward.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>If you don’t already have a personal development plan and/or
                                                career plan it is well worth investing the time to put one or
                                                both of these together. Ensure that you give yourself clear
                                                objectives and tangible actions that will help you to progress
                                                and make a real improvement. This will help you identify your
                                                goals and aspirations as well as how far you have gone to meet
                                                them.</p>

                                            <div className="border_subtitle">Complete a value/preference
                                                personality questionnaire
                                            </div>
                                            <p>It can be useful to gather more information to increase your
                                                levels of self-awareness and provide you with more information
                                                about your values and preferences. Take a personality test to
                                                measure your values and preferences in more detail. Some tests
                                                focused on values and preferences include:</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ul className="greenbullet-list">

                                                    <li>Hogan Motivation, Values and Preferences Inventory
                                                        (MVPI™)
                                                    </li>
                                                    <li>Saville Wave Questionnaire™</li>
                                                    <li>Myers Briggs Type Indicators Questionnaire (MBTI™)</li>
                                                </ul>
                                            </div>
                                            <p>Some of these tests are widely available, and others need to be
                                                administered by a qualified professional, such as a Pearn
                                                Kandola psychologist.</p>
                                            <p> Also, if you found this tool useful, then a good next step to
                                                take would be to go through the iLEAD™ tool ‘How to capitalise
                                                on self-awareness’. This will inform you not only how to put
                                                your newfound awareness of your own personal meanings to good
                                                use, but those of your colleagues as well.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad greennumberroundbg1 lightbgcontentShrink uiheading">
                                                <div className="border_subtitle">We’re all unique</div>
                                                <p>Everybody has different values and preferences and it is up
                                                    to you to decide how best to behave according to your
                                                    personal profile. Good luck!</p>
                                            </div>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}